/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AssetOcppConfigurationSnapshotDto } from './AssetOcppConfigurationSnapshotDto';
import {
    AssetOcppConfigurationSnapshotDtoFromJSON,
    AssetOcppConfigurationSnapshotDtoFromJSONTyped,
    AssetOcppConfigurationSnapshotDtoToJSON,
    AssetOcppConfigurationSnapshotDtoToJSONTyped,
} from './AssetOcppConfigurationSnapshotDto';

/**
 * 
 * @export
 * @interface GetAssetOcppConfigurationResponseDto
 */
export interface GetAssetOcppConfigurationResponseDto {
    /**
     * 
     * @type {string}
     * @memberof GetAssetOcppConfigurationResponseDto
     */
    assetId: string;
    /**
     * Null when configuration has never been successfully fetched from the charger. On the initial GET (when configurationFetchedAt is null), the API may fetch from the charger and persist a full snapshot before returning. Named snapshot to avoid OpenAPI client clashes with Configuration.
     * @type {AssetOcppConfigurationSnapshotDto}
     * @memberof GetAssetOcppConfigurationResponseDto
     */
    snapshot: AssetOcppConfigurationSnapshotDto | null;
    /**
     * ISO timestamp of the last successful fetch. Null means never fetched; the initial GET may then fetch, persist, and set this timestamp.
     * @type {Date}
     * @memberof GetAssetOcppConfigurationResponseDto
     */
    configurationFetchedAt: Date | null;
}

/**
 * Check if a given object implements the GetAssetOcppConfigurationResponseDto interface.
 */
export function instanceOfGetAssetOcppConfigurationResponseDto(value: object): value is GetAssetOcppConfigurationResponseDto {
    if (!('assetId' in value) || value['assetId'] === undefined) return false;
    if (!('snapshot' in value) || value['snapshot'] === undefined) return false;
    if (!('configurationFetchedAt' in value) || value['configurationFetchedAt'] === undefined) return false;
    return true;
}

export function GetAssetOcppConfigurationResponseDtoFromJSON(json: any): GetAssetOcppConfigurationResponseDto {
    return GetAssetOcppConfigurationResponseDtoFromJSONTyped(json, false);
}

export function GetAssetOcppConfigurationResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAssetOcppConfigurationResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'assetId': json['assetId'],
        'snapshot': AssetOcppConfigurationSnapshotDtoFromJSON(json['snapshot']),
        'configurationFetchedAt': (json['configurationFetchedAt'] == null ? null : new Date(json['configurationFetchedAt'])),
    };
}

export function GetAssetOcppConfigurationResponseDtoToJSON(json: any): GetAssetOcppConfigurationResponseDto {
    return GetAssetOcppConfigurationResponseDtoToJSONTyped(json, false);
}

export function GetAssetOcppConfigurationResponseDtoToJSONTyped(value?: GetAssetOcppConfigurationResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'assetId': value['assetId'],
        'snapshot': AssetOcppConfigurationSnapshotDtoToJSON(value['snapshot']),
        'configurationFetchedAt': value['configurationFetchedAt'] == null ? value['configurationFetchedAt'] : value['configurationFetchedAt'].toISOString(),
    };
}

